export default "__VITE_ASSET__BHBGiv7V__"